import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio, { RadioProps } from "@mui/material/Radio";
import MuiRadioGroup, { RadioGroupProps } from "@mui/material/RadioGroup";

import { TestProps } from "shared/types";

import Typography from "../Typography";

export type Option = string | number;

export interface RadioSelectOption {
  value: Option | JSX.Element;
  id: string;
}

interface RadioSelectProps<T extends RadioSelectOption>
  extends TestProps, Omit<RadioGroupProps, "onSelect"> {
  options: T[];
  selected?: string;
  onSelect: (value: T["id"]) => void;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  size?: RadioProps["size"];
}

const RadioGroup = <T extends RadioSelectOption>({
  options,
  selected,
  onSelect,
  size,
  label,
  disabled = false,
  required = false,
  testId,
}: RadioSelectProps<T>) => (
  <div data-testid={testId}>
    <FormControl disabled={disabled} required={required}>
      {label && <FormLabel>{label}</FormLabel>}
      <MuiRadioGroup
        value={selected || null}
        onChange={(_, v) => onSelect(v as T["id"])}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.id}
            value={option.id}
            control={<Radio role="radio" size={size} />}
            className="flex flex-row items-center"
            label={
              // pt-[7px] is to align the text with the radio button, since we are aligning to top (start)
              // to handle the case where the option.value is a complex element
              <Typography
                className="flex items-center"
                variant={size === "small" ? "body3" : "body2"}
              >
                {option.value}
              </Typography>
            }
          />
        ))}
      </MuiRadioGroup>
    </FormControl>
  </div>
);

export default RadioGroup;
